import {computed} from "mobx";
import {SPORT_TYPES_ALIAS_NAMES} from "../../../../core/app/consts";
import {AllScoresRoutePageModel} from "./all-scores-route.page-model";

export class AllScoresRoutePageDescriptionModel extends AllScoresRoutePageModel {
  @computed get description() {
    return this.isToday ? this.todayDescription : this.dateDescription
  }

  @computed get todayDescription() {
    if (this.isOnTv) {
      return this.onTvDescription
    } else if (this.isLive) {
      return this.liveValue || this.liveDescription
    } else {
      return this.mainValue || this.mainDescription
    }
  }

  @computed get dateDescription() {
    if (this.isYesterday) {
      return this.yesterdayValue || this.yesterdayDescription
    } else if (this.isTomorrow) {
      return this.tomorrowValue || this.tomorrowDescription
    } else if (this.isBeforeYesterday) {
      return this.matchResultsValue || this.matchResultsDescription
    } else if(this.isAfterTomorrow) {
      return this.matchFixturesValue || this.matchFixturesDescription
    } else {
      return this.datesDescription
    }
  }

  get mainDescription(): String {
    const sportTypeDescription = this.terms.SPORT_TYPE_HOME_DESCRIPTION_TEMPLATE.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD": this.terms.LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD,
      'SPORT_TYPE': this.sportType?.name,
    });

    const mainDescription = this.isHomePage ? this.terms.HOMEPAGE_DESCRIPTION_TEMPLATE : sportTypeDescription;

    return mainDescription;
  }

  get liveDescription(): String {
    const liveDescription = this.terms.LIVE_SCORES_DESCRIPTION_TEMPLATE.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD": this.terms.LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD,
      'SPORT_TYPE': this.sportType?.name
    });

    return liveDescription;
  }

  get datesDescription(): String {
    let description: String = this.terms.HP_SCORES_DATE_DESCRIPTION_TEMPLATE.format({
      'DATE': this.datetimeUtils.toShortDate(this.date),
      'SPORT_TYPE': this.sportType?.name
    });

    return description;
  }

  get yesterdayDescription(): String {
    const description: String = this.terms[`META_DESCRIPTION_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_YESTERDAY`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return description;
  }

  get tomorrowDescription(): String {
    const description: String = this.terms[`META_DESCRIPTION_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_TOMORROW`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return description;
  }

  get matchResultsDescription(): String {
    const description: String = this.terms[`META_DESCRIPTION_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_DATE_PREVIOUS`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return description;
  }

  get matchFixturesDescription(): String {
    const description: String = this.terms[`META_DESCRIPTION_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_DATE_NEXT`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return description;
  }


  get onTvDescription() {
    return this.terms.META_DESCRIPTION_CROSS_SPORT_TYPE_ON_TV;
  }
}